import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Styles
import './styles/style.css';

// Layout
import Layout from './components/Layout/Layout';

// Pages
import Home from './components/Home/Home';
import About from './components/About/About';
import IntelligenceEconomique from './components/Intelligence/IntelligenceEconomique';
import PublicationsList from './components/Publications/PublicationsList';
import PublicationDetail from './components/Publications/PublicationDetail';
import NewsList from './components/News/NewsList';
import NewsDetail from './components/News/NewsDetail';
import Subscriptions from './components/Subscriptions/Subscriptions';
import Contact from './components/Contact/Contact';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Dashboard from './components/Account/Dashboard';
import ProtectedRoute from './components/Auth/ProtectedRoute';

// Paiement
import PaymentForm from './components/Payment/PaymentForm';
import PaymentProcessing from './components/Payment/PaymentProcessing';
import PaymentSuccess from './components/Payment/PaymentSuccess';
import PaymentCancel from './components/Payment/PaymentCancel';

// Font Awesome
import '@fortawesome/fontawesome-free/css/all.min.css';

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="a-propos" element={<About />} />
            <Route path="intelligence-economique" element={<IntelligenceEconomique />} />
            <Route path="publications" element={<PublicationsList />} />
            <Route path="publication/:slug" element={<PublicationDetail />} />
            <Route path="actualites" element={<NewsList />} />
            <Route path="actualite/:slug" element={<NewsDetail />} />
            <Route path="abonnements" element={<Subscriptions />} />
            <Route path="contact" element={<Contact />} />
            <Route path="connexion" element={<Login />} />
            <Route path="inscription" element={<Register />} />
            
            {/* Routes de paiement */}
            <Route path="payment-form" element={<PaymentForm />} />
            <Route path="payment-processing" element={<PaymentProcessing />} />
            <Route path="payment-success" element={<PaymentSuccess />} />
            <Route path="payment-cancel" element={<PaymentCancel />} />
            
            <Route
              path="mon-compte"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;